export default {
  copyKimpleFolderSuccess: '¡Felicidades! Ya puedes acceder a la copia de esta carpeta Kimple desde tus carpetas personales, editarla y compartirla con tus colegas.',
  copyKimpleFolderError: 'Ha ocurrido un error. Por favor intenta nuevamente',
  addResourceToFolderSuccess: 'Cambios guardados'
}

export const en = {
  copyKimpleFolderSuccess: 'Congratulations! You can now access the copy of this Kimple folder from your personal folders, edit it and share it with your colleagues.',
  copyKimpleFolderError: 'An error occurred. Please try again',
  addResourceToFolderSuccess: 'Saved changes'
}

export const ca = {
  copyKimpleFolderSuccess: 'Enhorabona! Ja pots accedir a la còpia d\'aquesta carpeta Kimple des de les teves carpetes personals, editar-la i compartir-la amb els col·legues.',
  copyKimpleFolderError: 'S\'ha produït un error. Si us plau, torna-ho a intentar',
  addResourceToFolderSuccess: 'Canvis desats'
}
